export default {
  namespaced: true,
  state: {
    selectedDistrict: null,
    selectedStreetId: null,
    selectedStreetName: null
  },
  mutations: {
    SET_SELECTED_DISTRICT (state, district) {
      state.selectedDistrict = district || null
      if (!district) {
        state.selectedStreetId = null
        state.selectedStreetName = null
      }
    },
    SET_REGION_FILTER (state, payload) {
      const p = payload || {}
      state.selectedDistrict = p.district || null
      state.selectedStreetId = p.streetId != null ? String(p.streetId) : null
      state.selectedStreetName = p.streetName || null
    },
    CLEAR_REGION (state) {
      state.selectedDistrict = null
      state.selectedStreetId = null
      state.selectedStreetName = null
    }
  }
}
